import React from "react";
import Development from "../../components/development/Development";

function Order(){
    return(
        <div className="App">
            <Development/>
        </div>
    )
}

export default Order;